import { FrequencyItem } from './frequencyitem'

export const WeeklyFrequencyItem = new FrequencyItem({
  id: '94D9159E-EBF5-4735-BCC9-FF70F4BE5C26',
  name: 'weeklyFrequency',
  label: 'Weekly',
  type: 'WeeklyFrequency',
  key: '94D9159E-EBF5-4735-BCC9-FF70F4BE5C26',
})
export const DailyFrequencyItem = new FrequencyItem({
  id: 'B4DE1221-9B26-4454-BE0B-71D8CE1E8147',
  name: 'dailyFrequency',
  label: 'Daily',
  type: 'DailyFrequency',
  key: 'B4DE1221-9B26-4454-BE0B-71D8CE1E8147',
})
export const HourlyFrequencyItem = new FrequencyItem({
  id: 'BF918671-0274-43CB-9BB0-26ECD4CD20A5',
  name: 'hourlyFrequency',
  label: 'Hourly',
  type: 'HourlyFrequency',
  key: 'BF918671-0274-43CB-9BB0-26ECD4CD20A5',
})
export const MinuteFrequencyItem = new FrequencyItem({
  id: '9D7D983F-3C7E-45E9-B50F-DE4954734D37',
  name: 'minuteFrequency',
  label: 'Minute',
  type: 'MinuteFrequency',
  key: '9D7D983F-3C7E-45E9-B50F-DE4954734D37',
})
